import React from 'react'
import clsx from 'clsx'
import { ConfigProvider, Layout } from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import { MetisHeader } from './mendian/old/header/header'
import { SanwHeader } from './mendian/old/header/sanw-header'
import { MetisSideMenu } from './mendian/old/sidemenu/sidemenu'
import { MetisFooter } from './mendian/old/footer/footer'
import { MetisPopMenu } from './mendian/old/popmenu/popmenu'
import { NewMetisHeader } from './mendian/header/header'
import { NewMetisSideMenu } from './mendian/sidemenu/sidemenu'
import { NewMetisFooter } from './mendian/footer/footer'
import styles from './default.module.less'
import { getCookie } from '@/utils/common'

const loginType = getCookie('LOGIN_TYPE')
const isAnjukeQiye = loginType === 'threeNet'

const appClass = clsx(styles.app, {
  [styles.withMinHeight]: typeof (window.document as any).documentMode === 'undefined'
})

interface Props{
  children: React.ReactNode,
  grayLoading?: boolean;
  useNewLayout?: boolean; // 兼容是否强制新版灰度
  useOnlyNewLayout: boolean; // 控制版本切换入口
}

// placeholder 用来方便处理布局
const sideMenu = (
  <div>
    <MetisSideMenu className={styles.sideMenu} />
    <div className={styles.sideMenuPlaceholder} />
  </div>
)

const Metis = (props: Props) => {
  const { grayLoading = false } = props
  // 是否使用新布局
  const useNewLayout = props.useNewLayout && location.hostname.indexOf('qiye.anjuke.com') > -1
  let showHeader = true
  let showSide = true
  let showFooter = true
  let header = useNewLayout ? <NewMetisHeader className={styles.header} useOnlyNewLayout={props.useOnlyNewLayout} /> : <MetisHeader className={styles.header} useOnlyNewLayout={props.useOnlyNewLayout} />
  let isImmersion = false
  let maxWidth = false
  let appMaxWidth = false
  const layoutConfigIndex = location.pathname.lastIndexOf('__')
  // 判断是不是三网门店mix项目项目, 暂时mix混合项目导航不支持自动滚动
  const isMix = location.pathname.indexOf('solar/mix') > -1

  if (grayLoading) {
    showHeader = false
    showSide = false
    showFooter = false
  } else if (layoutConfigIndex !== -1) {
    const layoutConfigPath = location.pathname.substring(layoutConfigIndex + 2) // 忽略前缀 __
    layoutConfigPath.split('_').forEach(config => {
      switch (config) {
        case 'hh':
          showHeader = false
          break
        case 'sh':
          showHeader = true
          break
        case 'hl':
          showSide = false
          // 三网门店mix项目, app容器宽度拉满（for 珊瑚海loading状态）
          if (isMix) appMaxWidth = true
          break
        case 'sl':
          showSide = true
          break
        case 'hf':
          showFooter = false
          break
        case 'sf':
          showFooter = true
          break
        case 'mw':
          showSide = false
          maxWidth = true
          break
        // 兼容沉浸式页面，嵌入在电视屏幕，内容宽度100%
        case 'himmersion':
          isImmersion = true
          break
        case 'sw':
          header = useNewLayout ? <NewMetisHeader className={styles.header} useOnlyNewLayout={props.useOnlyNewLayout} /> : <SanwHeader className={styles.header} useOnlyNewLayout={props.useOnlyNewLayout} />
          break
        default:
      }
    })
  }

  if (isAnjukeQiye) {
    header = useNewLayout ? <NewMetisHeader className={styles.header} useOnlyNewLayout={props.useOnlyNewLayout} /> : <SanwHeader className={styles.header} useOnlyNewLayout={props.useOnlyNewLayout} />
  }

  const composeHeader = (
    <div>
      {header}
      {!isMix ? <div className={styles.headerPlaceholder} /> : null}
    </div>
  )

  return (
    <ConfigProvider prefixCls="solar-main-app" locale={zhCN}>
      {isImmersion
        ? (
        <div className={styles.outside}>
          <div className={clsx(styles.main, styles.immersionMain)}>
            <div className={styles.content}>
              <div className={clsx(appClass, styles.immersionApp)}>
                {props.children}
              </div>
            </div>
          </div>
        </div>)
        : (useNewLayout
            ? (
            <Layout className={clsx('is-layout-v2', styles.outside, styles.isNew)}>
              {showHeader && header}
              <Layout className={clsx({ [styles['is-sidemenu-hide']]: !showSide })} hasSider={showSide}>
                {showSide && <NewMetisSideMenu className={styles.sideMenu} />}
                <Layout className={styles.layout}>
                  <Layout.Content className={styles.content}>
                    {props.children}
                  </Layout.Content>
                  {showFooter && <NewMetisFooter />}
                </Layout>
              </Layout>
            </Layout>)
            : (
            <div className={clsx(styles.outside, isMix && styles.outsideMix)}>
              {showHeader && composeHeader}
              <div className={clsx(styles.main, maxWidth && styles.maxWidth)}>
                {showSide && sideMenu}
                <div className={styles.content}>
                  <div className={[appClass, maxWidth ? styles.maxWidth : '', appMaxWidth ? styles.appMaxWidth : ''].join(' ')}>
                    {props.children}
                  </div>
                  {showFooter && <MetisFooter />}
                </div>
              </div>
              {showSide && showFooter && <MetisPopMenu />}
            </div>)
          )
      }
    </ConfigProvider>
  )
}

export default Metis
